module.exports = __webpack_public_path__ + "images/lead-header@2x.7ff88ba90282c35aa1f4d3799396cafc.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/lead-header@2x.jpg
// module id = 1009
// module chunks = 0